import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { PreAuthRouteWithLayout } from '../../components';
import { Minimal as MinimalLayout } from '../../layouts';

import PbdqAgentChatProvider from './components/PbdqAgentChatContext';
import PbdqScrollToHash from './components/PbdqScrollToHash.comp';
import PbdqHomePageContent from './Home.page';
import PbdqSolutionsPageContent from './Solutions.page';
import PbdqCapabilitiesPageContent from './Capabilities.page';
import PbdqImpactPageContent from './Impact.page';
import PbdqPricingPageContent from './Pricing.page';
import PbdqGetStartedPageContent from './GetStarted.page';
import PbdqCosAssessmentsPageContent from './CosAssessments.page';
import PbdqSchoolCosReadinessPageContent from './SchoolCosReadiness.page';
import PbdqLearnCreatorPageContent from './LearnCreator.page';
import PbdqWorkforceAiReadinessPageContent from './WorkforceAiReadiness.page';
import PbdqProgramValidationPageContent from './ProgramValidation.page';
import PbdqDqEveryChildPageContent from './DqEveryChild.page';

// Hosts every /powered-by-dq/* page (except /powered-by-dq/chatbot, which
// stays its own independent top-level route — see Chatbot.page.jsx) behind
// ONE shared PbdqAgentChatProvider. Mounting the provider here, above this
// inner Switch, instead of once per page, is what lets the floating DQ Agent
// popup (and its conversation state) survive navigating between these pages:
// React Router's <Switch> unmounts/remounts the page that matches, but never
// unmounts this shell, so the provider and the widget it owns keep running
// underneath as the matched child changes.
const PbdqAppShell = () => (
    <PbdqAgentChatProvider>
        <PbdqScrollToHash />
        <Switch>
            <PreAuthRouteWithLayout component={PbdqHomePageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp" />
            <PreAuthRouteWithLayout component={PbdqSolutionsPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/solutions" />
            <PreAuthRouteWithLayout component={PbdqCapabilitiesPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/capabilities" />
            <PreAuthRouteWithLayout component={PbdqImpactPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/impact" />
            <PreAuthRouteWithLayout component={PbdqPricingPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/pricing" />
            <PreAuthRouteWithLayout component={PbdqGetStartedPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/get-started" />
            <PreAuthRouteWithLayout component={PbdqCosAssessmentsPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/cos-assessments" />
            <PreAuthRouteWithLayout component={PbdqSchoolCosReadinessPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/school-cos-readiness" />
            <PreAuthRouteWithLayout component={PbdqLearnCreatorPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/learncreator" />
            <PreAuthRouteWithLayout component={PbdqWorkforceAiReadinessPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/workforce-ai-readiness" />
            <PreAuthRouteWithLayout component={PbdqProgramValidationPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/program-validation" />
            <PreAuthRouteWithLayout component={PbdqDqEveryChildPageContent} exact layout={MinimalLayout} no_redirect={true} path="/powered-by-dq-exp/dqeverychild" />
            <Redirect to="/powered-by-dq-exp" />
        </Switch>
    </PbdqAgentChatProvider>
);

export default PbdqAppShell;
